import { cn } from "./utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const callVariants = cva(
    "[&>svg]:top-4 [&>svg]:left-4 [&>svg]:absolute relative p-4 [&>svg~*]:pl-10 border dark:border-slate-800 rounded-lg w-full [&>svg]:w-8 [&>svg]:h-8 text-sm [&>svg+div]:translate-y-[-3px]",
    {
        variants: {
            variant: {
                info: "bg-indigo-100 border-indigo-300 text-indigo-800 ",
                destructive: "bg-red-100 border-red-300 text-red-800",
                warning: "bg-amber-100 border-amber-300 text-amber-800",
                success: "bg-green-100 border-green-300 text-green-800",
            },
        },
        defaultVariants: {
            variant: "info",
        },
    }
);

const Call = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof callVariants>>(
    ({ className, variant, ...props }, ref) => (
        <div ref={ref} role="alert" className={cn(callVariants({ variant }), className)} {...props} />
    )
);
Call.displayName = "Call";

const CallTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
    ({ className, ...props }, ref) => (
        <h5 ref={ref} className={cn("mb-1 font-medium text-md leading-none tracking-tight", className)} {...props} />
    )
);
CallTitle.displayName = "CallTitle";

const CallDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
    ({ className, ...props }, ref) => (
        <div ref={ref} className={cn("text-sm [&_p]:leading-relaxed", className)} {...props} />
    )
);
CallDescription.displayName = "CallDescription";

export { Call, CallDescription, CallTitle };
